import { useMutation } from "@apollo/client/react";

import {
  ManagedUserGroupIntegration,
  ManagedUserGroupIntegrationCreateInput,
} from "types/generated";

import { UPDATE_MANAGED_USER_GROUP_INTEGRATION } from "../../gql";

const useUpdateGroupIntegration = () => {
  const [updateManagedUserGroupIntegration] = useMutation<{
    managedUserGroupIntegrationUpdate: ManagedUserGroupIntegration;
  }>(UPDATE_MANAGED_USER_GROUP_INTEGRATION, {
    refetchQueries: ["GetManagedUserGroupIntegrations"],
  });

  const onUpdate = (input: ManagedUserGroupIntegrationCreateInput) => {
    return updateManagedUserGroupIntegration({
      variables: {
        input: input,
      },
    });
  };

  return { onUpdate };
};

export default useUpdateGroupIntegration;
